// @ts-nocheck
import React from "react";
import { Provider } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { ConnectedRouter } from "connected-react-router";
import { ApolloProvider } from '@apollo/client';
import { ConfigProvider } from 'antd';
import "../Student/assets/stylesheets/global.sass"
import "../shared/assets/stylesheets/global.sass"
import fr from 'antd/lib/locale/fr_FR';

import store, { history} from '../Student/store';
import AntForm, { AntFormRailsNested, AntFormGooglePlaces, AntFormRichMarkdownEditor } from "@9troisquarts/ant-form";
import routes from "./routes";
import TranslationProvider from "../utils/TranslationProvider";
import graphqlClient from "../utils/graphqlClient";
import tenantTheme from "../utils/tenantTheme";
import flattenRoutes from "../utils/flattenRoutes";
import DropdownIndicator from "../shared/components/ReactSelect/DropdownIndicator";
import moment from 'moment';
import 'moment/locale/fr'
import { hasFeature } from "../utils/access";
import tracker from "../utils/tracker";
import UploadInput from "../shared/components/AntFormUpload";
import { useI18n } from "@9troisquarts/wand";

tracker.start();
tracker.setMetadata('environment', process.env.NODE_ENV || 'unset');

moment.locale('fr');

AntForm.configure({
  formProps: {
    layout: 'vertical',
  },
});

export const dictionary = {
  addColumnAfter: "Insert column after",
  addColumnBefore: "Insert column before",
  addRowAfter: "Insert row after",
  addRowBefore: "Insert row before",
  alignCenter: "Align center",
  alignLeft: "Align left",
  alignRight: "Align right",
  bulletList: "Bulleted list",
  checkboxList: "Todo list",
  codeBlock: "Code block",
  codeCopied: "Copied to clipboard",
  codeInline: "Code",
  createLink: "Create link",
  createLinkError: "Sorry, an error occurred creating the link",
  createNewDoc: "Create a new doc",
  deleteColumn: "Delete column",
  deleteRow: "Supprimer la ligne",
  deleteTable: "Supprimer le tableau",
  deleteImage: "Supprimer l'image",
  downloadImage: "Télécharger l'image",
  replaceImage: "Replace image",
  alignImageLeft: "Float left half width",
  alignImageRight: "Float right half width",
  alignImageDefault: "Center large",
  em: "Italic",
  embedInvalidLink: "Sorry, that link won’t work for this embed type",
  findOrCreateDoc: "Find or create a doc…",
  h1: "Titre 1",
  h2: "Titre 2",
  h3: "Titre 3",
  heading: "Titre",
  hr: "Divider",
  image: "Image",
  imageUploadError: "Sorry, an error occurred uploading the image",
  imageCaptionPlaceholder: "Write a caption",
  info: "Info",
  infoNotice: "Info notice",
  link: "Link",
  linkCopied: "Le lien a été copié",
  mark: "Highlight",
  newLineEmpty: "Tapez '/' pour insérer un contenu…",
  newLineWithSlash: "Keep typing to filter…",
  noResults: "Aucun résultat",
  openLink: "Ouvrir le lien",
  orderedList: "Liste ordonnée",
  pageBreak: "Page break",
  pasteLink: "Paste a link…",
  pasteLinkWithTitle: (title: string): string => `Paste a ${title} link…`,
  placeholder: "Placeholder",
  quote: "Quote",
  removeLink: "Remove link",
  searchOrPasteLink: "Search or paste a link…",
  strikethrough: "Strikethrough",
  strong: "Bold",
  subheading: "Subheading",
  table: "Table",
  tip: "Tip",
  tipNotice: "Tip notice",
  warning: "Warning",
  warningNotice: "Warning notice",
};


AntForm.addField('nested', {
  component: AntFormRailsNested,
  showFormItemError: false,
});

AntForm.addField('formasupUpload', {
  component: UploadInput,
});

AntForm.addField('places', {
  component: AntFormGooglePlaces,
  apiKey: "AIzaSyBSBiyQ2XtcOa2ja7ue_eQkTRVt2aWUmso",
  geocoding: true,
  autocompletionRequest: {
    componentRestrictions: { country: ['fr'] }
  },
  selectProps: {
    placeholder: 'Rechercher...',
    noOptionsMessage: () => 'Aucun résultat ne correspond à votre recherche',
    loadingMessage: () => "Recherche en cours...",
    classNamePrefix: 'talentsup-react-select',
    components: { DropdownIndicator },
  }
});

AntForm.addField('localisation', {
  component: AntFormGooglePlaces,
  apiKey: "AIzaSyBSBiyQ2XtcOa2ja7ue_eQkTRVt2aWUmso",
  geocoding: true,
  autocompletionRequest: {
    componentRestrictions: { country: ['fr'] },
    types: ['(regions)']
  },
  selectProps: {
    placeholder: 'Rechercher...',
    noOptionsMessage: () => 'Aucun résultat ne correspond à votre recherche',
    loadingMessage: () => "Recherche en cours...",
    components: { DropdownIndicator },
    formatOptionLabel: ({ label, value }) => {
      if(value?.terms?.length > 0) {
        return value.terms[0].value;
      }
      return label;
    },
    classNamePrefix: 'talentsup-react-select'
  }
});

type IProps = {
  user: any;
}

const { client } = graphqlClient({ url: '/public/graphql' });

const App: React.FC<IProps> = props => {
  document.body.classList.add(
    tenantTheme(props.school.main_color)
  );
  const { t } = useI18n();
  const rts = flattenRoutes(routes).filter(r => r.component).filter(hasFeature(props.school)).filter(hasFeature(props.client));
  return (
    <ConfigProvider locale={fr}>
      <Provider store={store(props)}>
        <ConnectedRouter history={history}>
          <ApolloProvider client={client}>
            <Switch>
              {rts.map(route => (
                <Route key={route.name} exact path={route.path} component={route.component} />
              ))}
            </Switch>
          </ApolloProvider>
        </ConnectedRouter>
      </Provider>
    </ConfigProvider>
  )
}

export default TranslationProvider(App);
